/**
 * 商品映射关系物料-查询详情
  GET /baseinfo/product/sku/material/detail
  接口ID：219514067
  接口地址：https://app.apifotwitter.com/link/project/4556737/apis/api-219514067
 */

import { get, post } from "../utils/fetch";

/**
 * id
 *
 * ProductSkuEntity
 */

/**
 * 映射的主品
 *
 * ProductSkuMappingVo
 */

export var apiBaseinfoProductSkuMaterialDetail = function apiBaseinfoProductSkuMaterialDetail(query) {
  return get({
    url: '/baseinfo/product/sku/material/detail',
    query: query
  });
};

/**
 * 保存虚拟仓库映射信息
  POST /baseinfo/wh/saveMapping
  接口ID：206378908
  接口地址：https://app.apifotwitter.com/link/project/4556737/apis/api-206378908
 */
export var apiBaseinfoWhSaveMapping = function apiBaseinfoWhSaveMapping(data) {
  return post({
    url: '/baseinfo/product/sku/material/submit',
    data: data
  });
};